module.exports = __webpack_public_path__ + "img/noCandidateDetails.c02a0262.svg";